// Range-aware decimal formatting for pane numeric slider labels.
//
// Display-only: picks a sensible number of decimal places from the value
// range so a ±2000 field-magnitude slider reads "-1958" instead of
// "-1957.976493750", while a ±1 slider keeps a couple of decimals. The
// underlying value is untouched — the pane's `min`/`max`/`step` and the
// stored param stay exactly as they are.

/** Decimal places scaled to the value range — roughly three significant
 *  figures across the span. Clamped to [0, 6]; non-positive or non-finite
 *  spans fall back to 2 (the prior fixed default). */
export function decimalsForSpan(span: number): number {
    if (!Number.isFinite(span) || span <= 0) return 2;
    return Math.max(0, Math.min(2 - Math.floor(Math.log10(span)), 6));
}

/** A pane `format` callback for a slider spanning [min, max]. */
export function rangeFormat(min: number, max: number): (v: number) => string {
    const decimals = decimalsForSpan(Math.abs(max - min));
    return (v) => (Number.isFinite(v) ? v.toFixed(decimals) : '–');
}
